import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { reducers } from './reducers';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const win: any = window;

const configureStore = () => {
  const composeEnhancers = win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    reducers,
    composeEnhancers(
      applyMiddleware(thunk)
    ),
  );

  return store;
};

export default configureStore;
